import { React, useState } from 'react';

import {
    Box,
    FormControl,
    Grid, Paper,
    TextField, Typography
} from '@mui/material';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';

const CheckSerasaCobranca = () => {
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitSerasa(e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            document: cpfCnpj
        });

        const response = await fetchFlask('checkSerasaCobranca', body);
        handleAlerta(response);
        setIsSubmit(false);
    };

    function handleAlerta(response) {
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
    }

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>Criar contrato</PageHeader>

            <form action='' method='POST' id='formApproveSerasa' onSubmit={submitSerasa}>
                <Grid container spacing={1} justifyContent='center' alignItems='center'>
                    <Grid item xs={5}>
                        <Paper elevation={3} sx={{ padding: 2, marginTop: '20px' }}>
                            <Grid container justifyContent='center' marginBottom={2}>
                                <Typography variant='h4' marginBottom={2}>Consultar no Serasa</Typography>
                                <Grid item xs={8}>
                                    <FormControl sx={{ display: 'flex' }}>
                                        <TextField
                                            required
                                            label='CPF ou CNPJ'
                                            value={cpfCnpj}
                                            inputProps={{ maxLength: 18 }}
                                            onChange={(e) => setCpfCnpj(maskCpfCnpj(e.target.value))}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container justifyContent="center">
                                <Grid item xs={6}>
                                    <FormControl sx={{ display: 'flex' }}>
                                        <SubmitButton isSubmit={isSubmit} >Pesquisa Serasa</SubmitButton>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
};

export default CheckSerasaCobranca;
